import { isDebugEnabled } from '../../App'

const messages = new Map<string, string>()

function render() {
  if (!isDebugEnabled()) return

  let el = document.getElementById('debug-overlay')

  if (messages.size === 0) {
    el?.remove()
    return
  }

  if (!el) {
    el = document.createElement('div')
    el.id = 'debug-overlay'
    el.style.cssText =
      'position:fixed;bottom:16px;left:16px;z-index:9999;font-family:monospace;font-size:12px;padding:8px 12px;background:rgba(0,0,0,0.8);color:white;border-radius:6px;'
    document.body.appendChild(el)
  }

  el.innerHTML = Array.from(messages.values()).join('<br>')
}

export const debugOverlay = {
  set(id: string, message: string) {
    messages.set(id, message)
    render()
  },
  remove(id: string) {
    messages.delete(id)
    render()
  },
}
